module.exports = __webpack_public_path__ + "img/newyorksour.022c05f5.jpg";